import {Component, OnDestroy} from '@angular/core';
import {UserService} from "../../../../@shared/services/user.service";
import {MatDialogRef} from "@angular/material/dialog";
import {MatTableDataSource} from "@angular/material/table";
import {IAuthLogs} from "./auth-history.interface";
import {Subject} from "rxjs";
import {filter, takeUntil} from "rxjs/operators";

@Component({
  selector: 'app-auth-history',
  templateUrl: './auth-history.component.html',
  styleUrls: ['./auth-history.component.scss']
})
export class AuthHistoryComponent implements OnDestroy {

  private readonly destroyed$: Subject<void> = new Subject<void>();
  public authLogsColumns = ['count', 'dateLogin', 'ip', 'country'];
  public dataSource: MatTableDataSource<IAuthLogs>;
  public isLoading: boolean = true;

  constructor(
    public dialogRef: MatDialogRef<AuthHistoryComponent>,
    private userService: UserService) {
    this.subscribeEmitters();
    this.userService.requestAuthLog();
  }

  ngOnDestroy() {
    this.destroyed$.next()
    this.destroyed$.complete();
  }

  close() {
    this.dialogRef.close();
  }

  private subscribeEmitters(): void {
    this.userService.authLogs$
      .pipe(
        takeUntil(this.destroyed$),
        filter(data => !!data))
      .subscribe((authLogs: IAuthLogs[]) => {
        this.dataSource = new MatTableDataSource(authLogs);
        this.isLoading = false;
      })
  }

}
